export default __webpack_public_path__ + "static/austin-distel-uLnmmE8Y0E4-unsplash-dd7b35a2c0425ddcdf22537b01504973.jpg";